import { Styles } from 'primase';

const styles = {
  unborderedBottom: {
    border: 0,
  },
  cardHeader: {
    background: Styles.color.blue[900],
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 900,
    color: Styles.color.gray[0],
    paddingTop: 5,
    paddingBottom: 5,
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    textAlign: 'end',
  },
  price: {
    fontSize: 16,
  },
  insurancePrice: {
    fontSize: 12,
    color: Styles.color.neutral.neutral7,
    lineHeight: '16px',
  },
  cardContent: {
    paddingTop: `${Styles.spacing.sp1}px`,
    paddingBottom: `${Styles.spacing.sp1}px`,
    paddingLeft: `${Styles.spacing.sp4}px`,
    paddingRight: `${Styles.spacing.sp4}px`,
    [`@media screen and (max-width: ${Styles.layout.Breakpoints.sm}px)`]: {
      padding: `${Styles.spacing.sp3}px`,
    },
  },
  orderContainer: {
    display: 'flex',
    flex: 1,
  },
  borderBottom: {
    borderBottom: `1px solid ${Styles.color.gray[300]}`,
    width: '100%',
    margin: 'auto',
  },
  insurancePriceContainer: {
    float: 'right' as const,
    width: '75%',
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    marginTop: 10,
  },
  totalSumContainer: {
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  totalSumMainText: {
    fontSize: 20,
    fontWeight: 'bold' as const,
  },
  billedIfAuthorizedLabel: {
    marginTop: 15,
    fontSize: 12,
    fontStyle: 'italic',
  },
  insuranceSum: {
    fontSize: 12,
    color: Styles.color.neutral.neutral7,
    lineHeight: '16px',
    [`@media screen and (max-width: ${Styles.layout.Breakpoints.sm}px)`]: {
      paddingLeft: 20,
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
};

export default styles;
